import { makeAutoObservable, runInAction } from "mobx";

export default class toolPassportStore {
  toolPassport = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.toolPassport = [];
    runInAction(() => {
      this.toolPassport = data;
    });
  };

  deleteToolPassport = (id) => {
    let newState = this.toolPassport.filter((toolPassport) => toolPassport.id !== id);
    this.toolPassport = [];
    this.toolPassport = newState;
  };
}